import React, { useState } from 'react';
import {
    Box,
    Container,
    Tab,
    Tabs,
    ImageList,
    ImageListItem,
    Modal,
    IconButton,
    useTheme,
    useMediaQuery,
    Fade
} from '@mui/material';
import { AppHeroView } from 'components/utils/AppHeroView';
import AppText from 'components/widgets/AppText';
import CloseIcon from '@mui/icons-material/Close';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import BusinessIcon from '@mui/icons-material/Business';
// import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import cargo_motors_achievements from 'assets/images/achievements/cargo_motors_achievements.jpg';
import krishna_auto_sales_2_achievement from 'assets/images/achievements/krishna_auto_sales_2_achievement.jpg';
import krishna_auto_sales_sangrur_achievement from 'assets/images/achievements/krishna_auto_sales_sangrur_achievement.jpg';
import libra_achievement from 'assets/images/achievements/libra_achievement.jpg';
import pasco_chandigarh_achievement from 'assets/images/achievements/pasco_chandigarh_achievement.jpg';
import pasco_ropar_achievement from 'assets/images/achievements/pasco_ropar_achievement.jpg';
import pps_achievement from 'assets/images/achievements/pps_achievement.jpg';

import fleet_1 from 'assets/images/fleets/fleet_1.jpeg'
import fleet_2 from 'assets/images/fleets/fleet_2.jpeg'
import fleet_3 from 'assets/images/fleets/fleet_3.jpeg'
import fleet_4 from 'assets/images/fleets/fleet_4.jpeg'
import fleet_5 from 'assets/images/fleets/fleet_5.jpeg'
import fleet_6 from 'assets/images/fleets/fleet_6.jpeg'
import fleet_7 from 'assets/images/fleets/fleet_7.jpeg'

const GalleryPage = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const galleryCategories = [
        {
            id: 'fleet',
            label: 'Our Fleet',
            icon: <LocalShippingIcon />,
            images: [
                {
                    img: fleet_1,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_2,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_3,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_4,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_5,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_6,
                    title: '',
                    description: ''
                },
                {
                    img: fleet_7,
                    title: '',
                    description: ''
                }
                // Add more fleet images
            ]
        },
        // {
        //     id: 'facilities',
        //     label: 'Facilities',
        //     icon: <BusinessIcon />,
        //     images: [
        //         {
        //             img: '/gallery/facilities/warehouse1.jpg',
        //             title: 'Main Warehouse',
        //             description: 'State-of-the-art warehouse facility'
        //         },
        //         {
        //             img: '/gallery/facilities/maintenance.jpg',
        //             title: 'Maintenance Center',
        //             description: 'Advanced maintenance facility'
        //         },
        //         // Add more facility images
        //     ]
        // },
        // {
        //     id: 'team',
        //     label: 'Our Team',
        //     icon: <GroupsIcon />,
        //     images: [
        //         {
        //             img: '/gallery/team/drivers.jpg',
        //             title: 'Professional Drivers',
        //             description: 'Our experienced driver team'
        //         },
        //         {
        //             img: '/gallery/team/staff.jpg',
        //             title: 'Support Staff',
        //             description: 'Dedicated support team'
        //         },
        //         // Add more team images
        //     ]
        // },
        {
            id: 'achievements',
            label: 'Achievements',
            icon: <EmojiEventsIcon />,
            images: [
                {
                    img: cargo_motors_achievements,
                    title: 'CARGO MOTORS',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: pps_achievement,
                    title: '10000 Deliveries',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: krishna_auto_sales_2_achievement,
                    title: 'Excellence Award 2024',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: libra_achievement,
                    title: 'Excellence Award 2024',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: pasco_chandigarh_achievement,
                    title: '10000 Deliveries',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: pasco_ropar_achievement,
                    title: 'Excellence Award 2024',
                    description: 'Industry recognition for service excellence'
                },
                {
                    img: krishna_auto_sales_sangrur_achievement,
                    title: '10000 Deliveries',
                    description: 'Industry recognition for service excellence'
                },
                // Add more achievement images
            ]
        }
    ];

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const getColumnCount = () => {
        if (isMobile) return 1;
        return 3;
    };

    // Zoom state as a percentage (default 100%)
    const [zoom, setZoom] = useState(100);

    // Handle image click to zoom in by 10% (up to 300%)
    // const handleImageClick = () => {
    //     setZoom((prev) => Math.min(prev + 10, 300));
    // };

    // Reset zoom when modal closes or image changes
    React.useEffect(() => {
        if (!selectedImage) setZoom(100);
    }, [selectedImage]);

    // Handle image click to zoom in by 10% (up to 300%)
    const handleImageClick = (e) => {
        if (e.shiftKey) {
            setZoom((prev) => Math.max(prev - 10, 100));
        } else {
            setZoom((prev) => Math.min(prev + 10, 300));
        }
    };

    return (
        <Box>
            <AppHeroView
                title="Gallery"
                description="Explore our fleet, facilities, team, and achievements through images"
            />

            <Container maxWidth="lg" sx={{ py: 4 }}>
                {/* Category Tabs */}
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ mb: 4 }}
                >
                    {galleryCategories.map((category, index) => (
                        <Tab
                            key={category.id}
                            icon={category.icon}
                            label={category.label}
                            iconPosition="start"
                        />
                    ))}
                </Tabs>

                {/* Image Gallery */}
                <ImageList
                    variant="masonry"
                    cols={getColumnCount()}
                    gap={16}
                >
                    {galleryCategories[activeTab].images.map((item, index) => (
                        <ImageListItem
                            key={index}
                            sx={{
                                cursor: 'pointer',
                                transition: 'transform 0.3s',
                                border: `2px solid ${theme.palette.divider}`,
                                borderRadius: theme.shape.borderRadius,
                                overflow: 'hidden',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                    borderColor: theme.palette.primary.main,
                                }
                            }}
                            onClick={() => setSelectedImage(item)}
                        >
                            <img
                                src={item.img}
                                alt={item.title}
                                loading="lazy"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                }}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>

                {/* Image Modal */}
                <Modal
                    open={Boolean(selectedImage)}
                    onClose={() => setSelectedImage(null)}
                    closeAfterTransition
                >
                    <Fade in={Boolean(selectedImage)}>
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 2,
                            borderRadius: theme.shape.borderRadius,
                        }}>
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    bgcolor: 'background.paper',
                                }}
                                onClick={() => setSelectedImage(null)}
                            >
                                <CloseIcon />
                            </IconButton>
                            <Box
                                sx={{
                                    pt: 3,
                                    textAlign: 'center',
                                    width: '80vw',
                                    maxWidth: '80vw',
                                    maxHeight: 'calc(90vh - 40px)',
                                    overflow: 'auto',
                                    mx: 'auto',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'inline-block',
                                        minWidth: '100px',
                                        minHeight: '100px',
                                    }}
                                >
                                    <img
                                        src={selectedImage?.img}
                                        alt={selectedImage?.title}
                                        onClick={handleImageClick}
                                        style={{
                                            maxWidth: zoom > 100 ? 'unset' : '100%',
                                            maxHeight: zoom > 100 ? 'unset' : 'calc(90vh - 100px)',
                                            width: 'auto',
                                            height: 'auto',
                                            objectFit: 'contain',
                                            cursor: zoom < 300 ? 'zoom-in' : 'default',
                                            transition: 'transform 0.3s',
                                            transform: `scale(${zoom / 100})`,
                                            display: 'block',
                                            margin: '0 auto',
                                        }}
                                    />
                                </Box>
                                <Box sx={{ mt: 2 }}>
                                    <AppText text={selectedImage?.title} variant="h6" />
                                    <AppText text={selectedImage?.description} color="text.secondary" />
                                    <AppText
                                        text={`Click image to zoom in, Shift+Click to zoom out (Current: ${zoom}%)`}
                                        color="text.secondary"
                                        variant="caption"
                                        sx={{ mt: 1 }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>
            </Container>
        </Box>
    );
};

export default GalleryPage;